import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Route} from '@react-navigation/native';
import {privilegesSelector} from '../../redux/selectors/privilege';
import View from './view';

export const PrivilegeDetailsScreen = ({route}: {route: Route<string>}) => {
  // @ts-ignore
  const id = route.params.id;
  const privileges = useSelector(privilegesSelector());
  const privilege = useMemo(
    () => privileges?.socialSupportMeasures?.find((x) => x.id === id) || null,
    [id, privileges],
  );

  return View({
    privilege,
  });
};
